<template>
    <FormulateForm
        v-model="values"
        :errors="inputErrors"
        :schema="schema"
        @submit="submitForm">

        <form-buttons :isLoading="isLoading"
                      @cancel="$emit('cancel')"></form-buttons>
    </FormulateForm>
</template>

<script>
import {cloneDeep} from 'lodash';

export default {
    name: 'BueroForm',
    props: {
        schema: Array,
        url: String,
        method: String,
        elementValues: Object,
        templateValues: Object,
    },
    data() {
        return {
            values: {},
            isLoading: false,
            path: this.url,
            inputErrors: null,
        };
    },

    created() {
        if (this.elementValues) {
            this.values = cloneDeep(this.elementValues);
        }
    },

    methods: {
        submitForm(data) {
            this.isLoading = true;

            let event = this.method === 'post' ? 'addItem' : 'updateItem';

            if (this.values.id !== '' && this.elementValues !== undefined) {
                this.path = this.url + '/' + this.elementValues.id;
            }

            axios({
                method: this.method,
                url: this.path,
                data: data,
            }).then((response) => {
                this.$emit(event, response.data.validated);
                this.$swal({
                    title: response.data.message,
                });
                this.isLoading = false;
            }).catch((error) => {
                this.inputErrors = error.response.data.errors;
                this.$swal({
                    icon: 'error',
                    title: 'Es ist ein Fehler aufgetreten',
                });
                this.isLoading = false;
            });
        },
    },
    watch: {
        templateValues: {
            handler(newValue) {
                this.values = newValue;
            },
        },
    },
};
</script>
